export const CREATE_BUTTON_ID = 'us_tbconfcreate';
export const CONFERENCE_MARKER_EVENT = 'us_evCONFMARKER';



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/conferencing/constants.js